var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from "react";
import { connect } from '../../store/connect';
import { BookingForm } from "../BookingForm/BookingForm";
import { useBookingFormSchema } from "../BookingForm/schema";
import { componentTypes } from "../Form/form-constants";
import { Modal } from "../Modal/Modal";
import get from "lodash/get";
import pick from "lodash/pick";
import omit from "lodash/omit";
import omitBy from "lodash/omitBy";
import debounce from "lodash/debounce";
import keyBy from "lodash/keyBy";
import keys from "lodash/keys";
import { getClassName, getHashOrPath, redirectToPage, scrollToParentTop, useIntegrationName } from "../../helpers";
import { ERoute } from "../../helpers/Routes";
import { useEmitter, useScopedEventName } from "../../helpers/customEvents";
import noop from "lodash/noop";
import { bookNow, submitBookingForm, updateCart, updateForm } from "../../store/actions";
import { BOOK_NOW_EVENT, CART_ITEMS_PATH, getFieldPaths, getPriceId, hasAllowAllEvents } from "../BookingForm/booking-form.helpers";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getBookDataPaginatedResponse, getCustomerData, getInitialData } from "../../store/actions/response.actions";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { getBookManager } from "../../models/BookModel";
import { pushToGlobalStore } from "../../store/store-helpers";
import { useConfig, usePresentationComponent } from "../../AppContext";
import parse from "html-react-parser";
import { BrowserNotSupported } from "../BrowserNotSupported/BrowserNotSupported";
import { FlashNotifications } from "../Notification/FlashNotifications";
import { isAdminIntegration } from "../../store/statePresenter";
import styled from "styled-components";
import { getBookingFormManager } from "../../FormManager/BookingFormManager";
import { ADD_TO_CART_POPUP, TO_BOOK_NOW_BUTTON, TO_CONTINUE_BUTTON, TO_CART_BUTTON } from "../../classConstants";
import querystring from 'querystring';
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { getBookDataResponseManager, isBookDataUpdated } from "../../models/BookModel/helpers";
var deriveValue = function (showBookNow, options, defaultValue) {
    switch (typeof showBookNow) {
        case "boolean":
            return showBookNow;
        case "function":
            return showBookNow(__assign(__assign({}, options), { defaultValue: defaultValue }));
    }
    return defaultValue;
};
var getCartButton = function (type, props, t, onClick) {
    var _a;
    var getIcon = function (prop, icon) {
        if (props.isAdminIntegration) {
            return icon;
        }
        return t(["cart." + prop, ""]) || icon;
    };
    var typeProps = {
        cart: function () {
            var _a;
            return ({
                className: getClassName(TO_CART_BUTTON, (_a = {}, _a[TO_CART_BUTTON + "-admin"] = props.isAdminIntegration, _a)),
                icon: props.buttonsWithIcon ? getIcon("add_to_cart_icon", "cart") : "",
                parseIcon: true,
                label: !props.isAdminIntegration ? t("cart.add_to_cart") : t("admin_booking_form.add_to_cart"),
                type: "submit",
                disabled: props.isSubmitting || props.disableAddToCartButton,
                onClick: onClick,
                key: "add_to_cart",
            });
        },
        booknow: function () {
            var _a;
            if (props.shouldShowContinueButton && !props.showBookNowButton) {
                return null;
            }
            var label = !props.isAdminIntegration ? t("cart.book_now") : props.shouldShowContinueButton ? t("admin_booking_form.express") : t("admin_booking_form.book_now");
            return {
                className: getClassName(TO_BOOK_NOW_BUTTON, (_a = {}, _a[TO_BOOK_NOW_BUTTON + "-admin"] = props.isAdminIntegration, _a)),
                icon: props.loadingBookNow ? "spinning" : props.buttonsWithIcon ? getIcon("book_now_icon", "offline-bolt") : "",
                parseIcon: true,
                variant: props.isAdminIntegration ? "primary-outline" : "primary",
                label: label,
                disabled: props.isSubmitting,
                type: "submit",
                onClick: onClick,
                key: "book_now",
            };
        },
        continue: function () {
            var _a;
            return ({
                className: getClassName(TO_CONTINUE_BUTTON, (_a = {}, _a[TO_CONTINUE_BUTTON + "-admin"] = props.isAdminIntegration, _a)),
                icon: props.buttonsWithIcon ? getIcon("continue", "arrowright") : "",
                parseIcon: true,
                label: !props.isAdminIntegration ? t("cart.continue") : t("admin_booking_form.continue"),
                type: "submit",
                disabled: props.isSubmitting || props.disableContinueButton,
                onClick: onClick,
                key: "continue",
            });
        }
    };
    return ((_a = typeProps[type]) === null || _a === void 0 ? void 0 : _a.call(typeProps)) || null;
};
var getStateProps = function (state, _a) {
    var _b, _c, _d;
    var name = _a.name;
    return {
        isAdmin: isAdminIntegration(state),
        form: get(state, "formReducer.forms." + name, null),
        customerData: (_c = (_b = getCustomerData(get(state, "responseReducer"))) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.body,
        initialData: (_d = getInitialData(get(state, "responseReducer"))) === null || _d === void 0 ? void 0 : _d.response,
        bookData: getBookDataPaginatedResponse(get(state, "responseReducer")),
        validationErrors: get(state, "appReducer.validationErrors") || {},
        hasServerFilters: get(state, "courseReducer.hasServerFilters"),
    };
};
var getForm = function (stateProps, props, localForm) {
    if (localForm === void 0) { localForm = null; }
    var isAdmin = stateProps.isAdmin, form = stateProps.form, customerData = stateProps.customerData, initialData = stateProps.initialData, bookData = stateProps.bookData, validationErrors = stateProps.validationErrors, hasServerFilters = stateProps.hasServerFilters;
    var initDataRM = initialData && getResponseManager(initialData), bookDataRM = getBookDataResponseManager(bookData), defaultFormData = bookDataRM === null || bookDataRM === void 0 ? void 0 : bookDataRM.form_data, bmOptions = {
        isAdminIntegration: isAdmin,
        name: props.name,
        customerData: customerData,
        defaultFormData: defaultFormData,
        hasServerFilters: hasServerFilters,
        showBookedItems: false,
        showSaveParticipants: false,
        showParticipantDropdown: false,
        disableAvailabilityCheck: false,
        isFixedTimespan: !!get(props, "attributes.ftimespans"),
        showCustomerSearchAndSelect: props.showCustomerSearchAndSelect,
        showTimespanSearchAndSelect: props.showTimespanSearchAndSelect,
    };
    if (!bookData || !initialData) {
        return null;
    }
    var em = getBookManager(__assign(__assign({}, bookDataRM === null || bookDataRM === void 0 ? void 0 : bookDataRM.entities), initDataRM === null || initDataRM === void 0 ? void 0 : initDataRM.entities()), __assign(__assign({}, initDataRM === null || initDataRM === void 0 ? void 0 : initDataRM.options()), bmOptions));
    return getBookingFormManager({ modelManager: em, form: localForm || form }, __assign(__assign({}, bmOptions), { addOnlyTimespanByDefault: true, defaultFormData: defaultFormData }));
};
var shouldDisableButtons = function (stateProps, _a) {
    var name = _a.name, props = __rest(_a, ["name"]);
    var isAdmin = stateProps.isAdmin, form = stateProps.form, customerData = stateProps.customerData, initialData = stateProps.initialData, bookData = stateProps.bookData, validationErrors = stateProps.validationErrors, hasServerFilters = stateProps.hasServerFilters;
    return {
        loadingBookNow: (function () {
            if (!isAdmin || !form) {
                return false;
            }
            if (!get(props, "shouldShowContinueButton")) {
                return false;
            }
            var customerId = (form === null || form === void 0 ? void 0 : form.customerId) || props.customerId;
            if (!customerId) {
                return false;
            }
            if (!get(customerData, customerId)) {
                return true;
            }
            return false;
        })(),
        showBookNowButton: (function () {
            var _a;
            if (!get(props, "shouldShowContinueButton")) {
                return false;
            }
            var localForm = isAdmin ? form : null;
            var customerId = (localForm === null || localForm === void 0 ? void 0 : localForm.customerId) || props.customerId;
            if (!localForm || !customerId) {
                return false;
            }
            if (!get(customerData, customerId)) {
                return false;
            }
            var quantitySelected = Number(get(localForm, "booking_data.cart_items.0.position.quantity"));
            var participantData = get(customerData, customerId + ".form_data.form_field.personal_data", []);
            if (quantitySelected !== 1 && quantitySelected !== (participantData === null || participantData === void 0 ? void 0 : participantData.length)) {
                return false;
            }
            if (!bookData || !initialData) {
                return false;
            }
            var requestBodyForm = getForm(stateProps, __assign({ name: name }, props), __assign(__assign({}, omit(form, "form_data")), { customerId: customerId }));
            if (!requestBodyForm) {
                return false;
            }
            var invalidFieldPaths = (_a = getForm(stateProps, __assign({ name: name }, props), requestBodyForm.toRequestBody())) === null || _a === void 0 ? void 0 : _a.state.getInvalidFieldPaths(validationErrors);
            return invalidFieldPaths.length === 0;
        })()
    };
};
var bookingformPopupFactory = function () {
    var BookingFormPopup = function (_a) {
        var onClose = _a.onClose, toWaitList = _a.toWaitList, props = __rest(_a, ["onClose", "toWaitList"]);
        var submitButtonRef = useRef(null);
        var shouldScrollToParentTop = useConfig("shouldScrollToParentTop", false)[0];
        var classNameGetter = useConfig("classNames.bookingForm", function () { return ""; })[0];
        var showAddToCart = useConfig("bookingFormPopup.showAddToCart")[0];
        var showBookNow = useConfig("bookingFormPopup.showBookNow")[0];
        var showPriceBreakup = useConfig("bookingFormPopup.showPriceBreakup", false)[0];
        var showContinue = useConfig("bookingFormPopup.showContinue")[0];
        var showBackButton = useConfig("bookingFormPopup.showBackButton")[0];
        var onBack = useConfig("bookingFormPopup.onBack")[0];
        var clearOnSubmit = useConfig("bookingFormPopup.clearOnSubmit", false)[0];
        var PopupComponent = usePresentationComponent(["bookingFormPopup", "modal"]) || Modal;
        var customerIdFromContext = useConfig("customerId", null)[0];
        var name = props.name;
        var integrationName = useIntegrationName();
        var scopedBookEventName = useScopedEventName(BOOK_NOW_EVENT);
        var bookNowEmitter = useEmitter(scopedBookEventName);
        var t = useTranslation().t;
        var attributes = omitBy(omit(__assign(__assign({}, props.attributes), { ftimespans: props.timespanId }), "integrationName"), function (v) { return !v; });
        var query = querystring.stringify(attributes);
        var bookEntities = props.bookEntities;
        var cartItemsRef = useRef(props.cartItems);
        cartItemsRef.current = props.cartItems;
        var bm = useRef(null);
        var disableAvailabilityCheck = props.disableAvailabilityCheck;
        useEffect(function () {
            if (!bookEntities || keys(bookEntities).length === 0)
                return;
            bm.current = getBookManager(bookEntities, { isAdminIntegration: props.isAdminIntegration, disableAvailabilityCheck: disableAvailabilityCheck });
        }, [props.timespanId, JSON.stringify(bookEntities), disableAvailabilityCheck]);
        var getBookingFormProps = function () { return ({
            name: name,
            queryString: query,
            className: ADD_TO_CART_POPUP,
            customerId: customerIdFromContext,
            attributes: __assign(__assign({}, props.attributes), { ftimespans: props.timespanId }),
            filterPrefix: "",
            hideTopForm: true,
            isAdminIntegration: props.isAdminIntegration,
            showTimespanSearchAndSelect: props.showTimespanSearchAndSelect,
            showCustomerSearchAndSelect: props.showCustomerSearchAndSelect,
            onSubmit: noop,
            apiCancelToken: props.apiCancelToken,
            getSchema: function (schema, _a) {
                var className = _a.className;
                return bookingFormSchema.getEventFormSchema(schema, {
                    className: getClassName(className, classNameGetter({ itemCount: props.cartItems.length })),
                    component: componentTypes.FIELD_SET
                });
            }
        }); };
        var handleAddToCart = function (formValues, formApi) {
            var _a, _b;
            var modelManager = bm.current;
            var flattenedItems = cartItemsRef.current;
            if ((_a = flattenedItems === null || flattenedItems === void 0 ? void 0 : flattenedItems[0]) === null || _a === void 0 ? void 0 : _a.booking_data) {
                flattenedItems = flattenedItems.reduce(function (items, item) { return items.concat(get(item, "booking_data.cart_items")); }, []);
            }
            var formManager = getBookingFormManager({ modelManager: modelManager, form: formValues });
            var priceId = getPriceId(formValues);
            var cartItemToAdd = pick(formValues, ["booking_data"]);
            var cartItemToAddCartItems = get(cartItemToAdd, CART_ITEMS_PATH, []);
            var priceIds = get(formValues, CART_ITEMS_PATH, []).map(function (item) { return get(item, "position.price_id", 0); });
            var priceModels = keyBy(modelManager === null || modelManager === void 0 ? void 0 : modelManager.prices().whereIn("id", priceIds).all(), "id");
            var cartItemWithLowestQuantity = null;
            var updatedItems = formManager.mergedCartItems(flattenedItems);
            for (var _i = 0, updatedItems_1 = updatedItems; _i < updatedItems_1.length; _i++) {
                var item = updatedItems_1[_i];
                if (!(Number(+priceId !== +get(item, "position.parent_price_id")) ^ Number(+priceId !== +get(item, "position.price_id"))))
                    continue;
                var _c = get(item, "position", {}), _d = _c.price_id, price_id = _d === void 0 ? null : _d, _e = _c.quantity, quantity = _e === void 0 ? 0 : _e;
                if (!price_id) {
                    break;
                }
                if (priceModels[price_id] && get(priceModels[price_id], "max_quantity_left", 0) < +quantity) {
                    cartItemWithLowestQuantity = item;
                    break;
                }
                break;
            }
            var timespanModel = (_b = formManager.state.rootCartItems[0]) === null || _b === void 0 ? void 0 : _b.timespan;
            var title = (timespanModel === null || timespanModel === void 0 ? void 0 : timespanModel.getAsTitle([], { placement: "bookcart", titleKey: "timespan_format" }, { priceId: priceId })) || "";
            if (cartItemWithLowestQuantity) {
                var _f = get(cartItemWithLowestQuantity, "position").price_id, price_id_1 = _f === void 0 ? 0 : _f;
                var priceModel = priceModels[price_id_1];
                var quantity = +get(cartItemToAddCartItems.find(function (_a) {
                    var position = _a.position;
                    return position.price_id === price_id_1;
                }), "position.quantity", 0);
                var maxQuantity = +(priceModel === null || priceModel === void 0 ? void 0 : priceModel.max_quantity_left);
                var text_1 = parse(t("cart.item_quantity_left_exceeded", {
                    name: price_id_1 === priceId ? title : (priceModel === null || priceModel === void 0 ? void 0 : priceModel.get("presented.customerTitle")),
                    difference: Math.max(maxQuantity - quantity, 0),
                    maxQuantity: maxQuantity,
                    quantity: quantity
                }));
                var CartAddFail = function () { return React.createElement(React.Fragment, null,
                    " ",
                    text_1,
                    " "); };
                toast.error(React.createElement(CartAddFail, null));
                return false;
            }
            props.updateCart(updatedItems);
            var RenderTitle = function () { return React.createElement(React.Fragment, null,
                parse(t("cart.item_added_to_cart", {
                    count: cartItemToAddCartItems.filter(function (item) { return +get(item, "position.quantity", 0) > 0; }).length,
                    title: title
                })),
                " "); };
            toast.success(React.createElement(RenderTitle, null));
            clearOnSubmit && setTimeout(function () { return formApi.reset(omit(pick(formValues, ["customerId", "admin_config_toggles", "additional_props"]), ["additional_props.search_n_select"])); });
        };
        var handleBookNow = function () { return __awaiter(void 0, void 0, void 0, function () {
            var otherStages, request;
            var _a, _b;
            return __generator(this, function (_c) {
                otherStages = (_a = bm.current) === null || _a === void 0 ? void 0 : _a.getFormSteps(props.formManager.state, {});
                request = (_b = get(props, "formManager")) === null || _b === void 0 ? void 0 : _b.toRequestBody(getFieldPaths(otherStages));
                props.submitBookingForm(request, ERoute.BOOKCART);
                return [2 /*return*/];
            });
        }); };
        var handleContinue = function (formValues) {
            var _a;
            var formManager = getBookingFormManager({ modelManager: bm.current, form: formValues }, { takePersonalIndices: props.isAdminIntegration });
            var cartItems = formManager.mergeCart([]).toJSON().booking_data.cart_items;
            var formData = { customerId: formValues.customerId, booking_data: { cart_items: cartItems }, form_data: formValues.bookingId ? formManager.toRequestBody(getFieldPaths((_a = bm.current) === null || _a === void 0 ? void 0 : _a.getFormSteps(props.formManager.state, {}))).form_data : {} };
            props.bookNow(formData);
            bookNowEmitter(formData);
            pushToGlobalStore(integrationName, { form: formData });
            redirectToPage(getHashOrPath(ERoute.CHECKOUT, props.integrationUrl));
        };
        var onSubmit = function (callback) { return debounce(function (e, state, formApi) {
            var _a;
            if (e.target !== submitButtonRef.current) {
                e.preventDefault();
                e.stopPropagation();
                (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.click();
            }
            if (!(state === null || state === void 0 ? void 0 : state.valid))
                return;
            var returnValue = callback(state.values, formApi);
            if (returnValue === false)
                return;
            onClose();
            shouldScrollToParentTop && scrollToParentTop(submitButtonRef);
        }, 500, { leading: true }); };
        var continueCallback = onSubmit(handleContinue);
        var bookNowCallback = onSubmit(handleBookNow);
        var addToCartCallback = onSubmit(handleAddToCart);
        var deriveProps = { itemsCount: props.cartItems.length, };
        var shouldShowBackButton = deriveValue(showBackButton, deriveProps, props.showBackButton);
        var shouldShowAddToCartButton = !toWaitList && deriveValue(showAddToCart, deriveProps, props.hasCart);
        var shouldShowBookNowButton = deriveValue(showBookNow, deriveProps, props.hasBookingButton);
        var shouldShowContinueButton = deriveValue(showContinue, deriveProps, props.shouldShowContinueButton);
        var backButton = shouldShowBackButton && onBack ? { label: t("cart.back"), type: "button", variant: "clear", onClick: onBack } : null;
        var addToCartButton = shouldShowAddToCartButton ? getCartButton("cart", props, t, addToCartCallback) : null;
        var continueButton = shouldShowContinueButton ? getCartButton("continue", props, t, continueCallback) : null;
        var bookNowButton = shouldShowBookNowButton ? getCartButton("booknow", __assign(__assign({}, props), { shouldShowContinueButton: shouldShowContinueButton }), t, shouldShowContinueButton ? bookNowCallback : continueCallback) : null;
        var buttons = (props.isAdminIntegration
            ? [backButton, addToCartButton, bookNowButton, continueButton,]
            : [backButton, addToCartButton, continueButton, bookNowButton,]).filter(Boolean);
        var bookingFormSchema = useBookingFormSchema(name, buttons, {
            showCourseMeta: !props.isAdminIntegration,
            children: React.createElement(FormSubmitWrap, null,
                React.createElement("button", { className: "fakeField", ref: submitButtonRef, type: "submit" })),
            isAdminIntegration: props.isAdminIntegration,
            showPriceBreakup: showPriceBreakup,
        });
        var getBookingForm = function () {
            var formProps = getBookingFormProps();
            return (React.createElement(BookingFormWrap, null,
                React.createElement(BookingForm, __assign({}, formProps))));
        };
        return (React.createElement(PopupComponent, { onClose: onClose },
            React.createElement(BrowserNotSupported, { className: "browserNotSupported" }),
            React.createElement(FlashNotifications, null),
            getBookingForm()));
    };
    BookingFormPopup.defaultProps = {
        onClose: noop
    };
    var mapStateToProps = function (state, ownProps) {
        var _a;
        var name = "form-0";
        var adminIntegration = isAdminIntegration(state);
        var stateProps = __assign({ name: name, isAdminIntegration: adminIntegration, disableAvailabilityCheck: adminIntegration ? hasAllowAllEvents(get(state, "formReducer.forms.adminsettings")) : false, cartItems: get(state, "cartReducer.cart_items", []), isSubmitting: new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.POST_BOOKING_FORM,] }).loading }, getStateProps(state, ownProps));
        var form = getStateProps(state, { name: name }).form;
        return __assign(__assign({}, stateProps), { toWaitList: form && ((_a = getForm(stateProps, ownProps, form)) === null || _a === void 0 ? void 0 : _a.state.toWaitList) });
    };
    var mergeProps = function (stateProps, dispatchProps, ownProps) {
        var _a, _b;
        var bookData = stateProps.bookData, cartItems = stateProps.cartItems, initialData = stateProps.initialData, isAdminIntegration = stateProps.isAdminIntegration, name = stateProps.name, disableAvailabilityCheck = stateProps.disableAvailabilityCheck, others = __rest(stateProps, ["bookData", "cartItems", "initialData", "isAdminIntegration", "name", "disableAvailabilityCheck"]);
        var options = initialData && ((_a = getResponseManager(initialData)) === null || _a === void 0 ? void 0 : _a.options());
        var bookEntities = (_b = getBookDataResponseManager(bookData)) === null || _b === void 0 ? void 0 : _b.entities;
        return __assign(__assign(__assign(__assign(__assign(__assign({ name: name }, others), ownProps), { disableAvailabilityCheck: disableAvailabilityCheck,
            isAdminIntegration: isAdminIntegration, hasCart: !!(isAdminIntegration ? get(options, "admin_booking_form_show_add_to_cart", true) : get(options, "enable_cart")), hasBookingButton: get(options, "enable_book_now_from_cart_popup", true), cartItems: cartItems,
            bookEntities: bookEntities }), dispatchProps), shouldDisableButtons(stateProps, __assign(__assign({}, ownProps), { ftimespans: ownProps.timespanId }))), { formManager: getForm(stateProps, ownProps) });
    };
    return connect(mapStateToProps, { updateCart: updateCart, updateForm: updateForm, bookNow: bookNow, submitBookingForm: submitBookingForm }, mergeProps, isBookDataUpdated("bookData"))(BookingFormPopup);
};
export var BookingFormPopup = bookingformPopupFactory();
var FormSubmitWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  visibility: hidden !important;\n  position: fixed !important;\n  pointer-events: none !important;\n  z-index: -100 !important;\n"], ["\n  visibility: hidden !important;\n  position: fixed !important;\n  pointer-events: none !important;\n  z-index: -100 !important;\n"])));
var BookingFormWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .", ":not(.", "-admin),\n    .", ":not(.", "-admin),\n    .", ":not(.", "-admin) {\n        display: flex;\n        --size: var(--ws-add-to-cart-popup-buttons-size,.8em);\n\n        svg, > img {\n            flex-shrink: 0;\n            margin-right: 1em;\n            align-self: center;\n        }\n\n        svg {\n            width: var(--size);\n            height: var(--size);\n        }\n        img {\n            max-width: var(--size);\n            max-height: var(--size);\n        }\n    }\n"], ["\n    .", ":not(.", "-admin),\n    .", ":not(.", "-admin),\n    .", ":not(.", "-admin) {\n        display: flex;\n        --size: var(--ws-add-to-cart-popup-buttons-size,.8em);\n\n        svg, > img {\n            flex-shrink: 0;\n            margin-right: 1em;\n            align-self: center;\n        }\n\n        svg {\n            width: var(--size);\n            height: var(--size);\n        }\n        img {\n            max-width: var(--size);\n            max-height: var(--size);\n        }\n    }\n"])), TO_CART_BUTTON, TO_CART_BUTTON, TO_CONTINUE_BUTTON, TO_CONTINUE_BUTTON, TO_BOOK_NOW_BUTTON, TO_BOOK_NOW_BUTTON);
var templateObject_1, templateObject_2;
